// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3GE0K","insightsList":"newBusinessInsightsMenu_insightsList__3T8fC","active":"newBusinessInsightsMenu_active__djTtO"};